function parseBoolParam(value, { allowNull = false } = {}) {
  if (value === false) return false;

  if (value?.trim) value = value.trim();
  if (value?.toLowerCase) value = value.toLowerCase();

  if (allowNull && !value) return null;

  return value === true || value === '1' || value === 'true' || value === 'yes' || value === 'on';
}

export default parseBoolParam;
